interface DataType {
   id: number;
   page: string;
   icon?: string;
   icon_2?: string;
   icon_3?: string;
   title: string;
   desc: string;
};

const feature_data: DataType[] = [
   {
      id: 1,
      page: "home_1",
      icon: "/assets/img/icons/features_icon01.svg",
      title: "Learn with Experts",
      desc: "Curate anding area share Pluralsight content to reach your",
   },
   {
      id: 2,
      page: "home_1",
      icon: "/assets/img/icons/features_icon02.svg",
      title: "Learn Anything",
      desc: "Curate anding area share Pluralsight content to reach your",
   },
   {
      id: 3,
      page: "home_1",
      icon: "/assets/img/icons/features_icon03.svg",
      title: "Get Online Certificate",
      desc: "Curate anding area share Pluralsight content to reach your",
   },
   {
      id: 4,
      page: "home_1",
      icon: "/assets/img/icons/features_icon04.svg",
      title: "E-mail Marketing",
      desc: "Curate anding area share Pluralsight content to reach your",
   },

   // home_2

   {
      id: 1,
      page: "home_2",
      icon_2: "/assets/img/icons/h2_features_icon01.svg",
      title: "Expert Tutors",
      desc: "when an unknown printer took a galley offe type and scrambled makes.",
   },

   {
      id: 2,
      page: "home_2",
      icon_2: "/assets/img/icons/h2_features_icon02.svg",
      title: "Effective Courses",
      desc: "when an unknown printer took a galley offe type and scrambled makes.",
   },

   {
      id: 3,
      page: "home_2",
      icon_2: "/assets/img/icons/h2_features_icon03.svg",
      title: "Earn Certificate",
      desc: "when an unknown printer took a galley offe type and scrambled makes.",
   },

   // home_3

   {
      id: 1,
      page: "home_3",
      icon_2: "assets/img/icons/h3_features_icon01.svg",
      title: "Scholarship Facility",
      desc: "Eestuidar University we prepare you to launch your.",
   },
   {
      id: 2,
      page: "home_3",
      icon_2: "assets/img/icons/h3_features_icon02.svg",
      title: "Learn From Experts",
      desc: "Eestuidar University we prepare you to launch your.",
   },
   {
      id: 3,
      page: "home_3",
      icon_2: "assets/img/icons/h3_features_icon03.svg",
      title: "Graduation Courses",
      desc: "Eestuidar University we prepare you to launch your.",
   },
   {
      id: 4,
      page: "home_3",
      icon_2: "assets/img/icons/h3_features_icon04.svg",
      title: "Certificate Program",
      desc: "Eestuidar University we prepare you to launch your.",
   },

   // home_4

   {
      id: 1,
      page: "home_4",
      icon: "/assets/img/icons/h4_features_icon01.svg",
      title: "Support & Motivation",
      desc: "We are able to offer every yoga training experienced & best yoga trainer.",
   },
   {
      id: 2,
      page: "home_4",
      icon: "/assets/img/icons/h4_features_icon02.svg",
      title: "Strong Body Life",
      desc: "We are able to offer every yoga training experienced & best yoga trainer.",
   },
   {
      id: 3,
      page: "home_4",
      icon: "/assets/img/icons/h4_features_icon03.svg",
      title: "Increased Flexibility",
      desc: "We are able to offer every yoga training experienced & best yoga trainer.",
   },

   // home-five

   {
      id: 1,
      page: "home_5",
      icon_3: "/assets/img/others/h5_features_item_shape02.svg",
      icon_2: "skillgro-video-tutorial",
      title: "Easy Class",
      desc: "Dear Psum Dolor Amettey Adipis Aecing Eiusmod Incididutt Reore",
   },
   {
      id: 2,
      page: "home_5",
      icon_3: "/assets/img/others/h5_features_item_shape02.svg",
      icon_2: "skillgro-verified",
      title: "Safety & Security",
      desc: "Dear Psum Dolor Amettey Adipis Aecing Eiusmod Incididutt Reore",
   },
   {
      id: 3,
      page: "home_5",
      icon_3: "/assets/img/others/h5_features_item_shape02.svg",
      icon_2: "skillgro-instructor",
      title: "Skilled Teacher",
      desc: "Dear Psum Dolor Amettey Adipis Aecing Eiusmod Incididutt Reore",
   },
   {
      id: 4,
      page: "home_5",
      icon_3: "/assets/img/others/h5_features_item_shape02.svg",
      icon_2: "skillgro-book-1",
      title: "Clean Curriculum",
      desc: "Dear Psum Dolor Amettey Adipis Aecing Eiusmod Incididutt Reore",
   },

   // home_8

   {
      id: 1,
      page: "home_8",
      icon_3: "/assets/img/others/h5_features_item_shape02.svg",
      icon_2: "skillgro-book-1",
      title: "Learn skills with 120k+",
      desc: "video courses.",
   },
   {
      id: 2,
      page: "home_8",
      icon_3: "/assets/img/others/h5_features_item_shape02.svg",
      icon_2: "skillgro-instructor",
      title: "Choose courses",
      desc: "real-world experts.",
   },
   {
      id: 3,
      page: "home_8",
      icon_3: "/assets/img/others/h5_features_item_shape02.svg",
      icon_2: "skillgro-tutorial",
      title: "processional Tutors",
      desc: "video courses.",
   },
   {
      id: 4,
      page: "home_8",
      icon_3: "/assets/img/others/h5_features_item_shape02.svg",
      icon_2: "skillgro-graduated",
      title: "Online Degrees",
      desc: "Study flexibly online",
   },

];

export default feature_data;